module.exports = __webpack_public_path__ + "img/5-min.0b3fb2b6.jpg";